<template>
    <div class="cont-body">

        <pagination-info ref="pagination-info" />
        <pagination ref="pagination" @pagination:change-page="paginate" />
        
        <div id="cont-daily-log" class="cont-container">
			<header>
				<h1>Daily Glucose Log</h1>
				<p class="cont-subhead" id="cont-dateRange">
					<span></span>
				</p>
			</header>
            <div id="cont-hover-data" class="cont-hover-data"></div>
            <div id="cont-graphs"></div>
            <footer id="cont-legend" class="cont-legend">
                <p>Legend</p>
                <span class="key high">High Glucose (>250)</span>
                <span class="key low">Low Glucose (&lt;70)</span>
                <span class="key circle nofill">Scans/Views</span>
                <span class="key nofill noborder">
                    <span class="material-icons-outlined green">vaccines
                    </span>
                    Logged
                </span>
                <!-- placeholder icon -->
                <span class="key nofill grey-5">Post-Mean Peak</span>
                <span class="key circle">New Sensor</span>
                <span class="key nofill noborder">
                    <span class="material-icons-outlined"> schedule </span>
                    Time Change
                    </span>
                <div>
                    <span class="cont-grey-6">17.0?</span><span class="cont-grey-5">-2.0+0.0</span>
                    <span
                        class="key nofill grey-8"
                        data-keytext="15.0?"
                        style="padding: 0.5em 0.25em; margin-inline: 0.125em">
                        Meal + Correction + User Change = Total
                    </span>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>

import * as d3 from 'd3'
import { requestContinuousGlucose } from '@/api/dataApi';
import Pagination from '@/components/includes/pagination/Pagination';
import PaginationInfo from '@/components/includes/pagination/PaginationInfo';

export default {
    name: 'cont-graph',
    // props: {
    //     data: Array
    // },
    components: {
        Pagination,
        PaginationInfo
    },
    data() {
        let measurements = { top: 30, right: 30, bottom: 10, left: 60 }
        return {
            allData: null,
            scannedData: null,

            margin: measurements,
            width: 1100 - measurements.left - measurements.right,
            height: 300 - measurements.top - measurements.bottom,
            dateObj: d3.timeParse('%m/%d/%Y'),
            timeObj: d3.timeParse('%H:%M'),
            abbrWeekday: d3.timeFormat('%a'), // e.g. Mon
            weekday: d3.timeFormat('%A'), // e.g. Monday
            shortDate: d3.timeFormat('%b %d'), // e.g. Mar 7
            longDate: d3.timeFormat('%B %d'), // e.g. March 7
            longDateYr: d3.timeFormat('%B %d, %Y'), // e.g. March 7, 2022
            timeTwentyFour: d3.timeFormat('%H:%M'), // e.g. 13:25
            timeTwelve: d3.timeFormat('%-I:%M%p') // e.g. 3:15PM
        }
    },
    mounted() {
        this.paginate(1)
        
    },
    methods: {
        pageFactory(page, totalPages) {
            const pagination = {};
            pagination.from = /* this.countPerPage */ 7 * (page - 1) + 1;
            pagination.to = Math.min(7 * totalPages, /* this.countPerPage */ 7 * page);
            pagination.currentPage = page;
            pagination.total = 7 * totalPages;
            pagination.totalPage = totalPages;

            this.$refs['pagination-info'].setPaginationData(pagination);
            this.$refs['pagination'].setPaginationData(pagination);
        },
        paginate(curPage) {
            let loader = this.$loading.show({},{
                after: this.$createElement('div',{},['Loading page...'])
            });
            requestContinuousGlucose({}).then((item) => {
                this.pageFactory(curPage, item.pageCount)
            })
            requestContinuousGlucose({pageInfo:{page:curPage-1}}).then((item) => {
                this.allData = item.data
                this.scannedData = item.scannedData
                if(item.data.length === 0)
                return
                console.log(this.allData, this.scannedData)
                const testData = this.setDateRange(this.allData, this.allData[this.allData.length-1].date, this.allData[0].date);
                console.log(testData)
                d3.select('#cont-graphs').html(null)
                Object.keys(testData)./*reverse().*/forEach(key => {
                    if (testData[key].length != 0)
                        this.createGrid(testData[key])
                })
            }).finally(() => {
                loader.hide()
                loader = null
            })
        },
        // get data for one day
        getDailyData(dat, date) {
            if (!dat.length > 0) return console.log('No data provided');
            let formatter = d3.timeFormat('%m/%d/%Y');

            return dat.filter(d => {
                return +(this.dateObj(d.date)) === +(this.dateObj(formatter(date)));
            });
        },
        setDateRange(dat, start, end) {
            // filter data, return only selected range
            const filtered = dat.filter(d => {
                return (
                    +(this.dateObj(d.date)) >= +(this.dateObj(start)) && +(this.dateObj(d.date)) <= +(this.dateObj(end))
                );
            });
            /*
            console.dir(start);
            console.dir(end);
            console.dir(this.dateObj(start));
            console.dir(this.dateObj(end));
            console.dir(this.dateObj(start).getDate());
            console.dir(this.dateObj(start).getDate()+1);
            */
            let days = [];
            for(const [index,item] of filtered.entries())
              if(index === 0 || filtered[index-1].day !== item.day)
                days.push(item.date);
            const daysCount = days.length;

            // array of data objects for each day in range
            let daily = {};
            let date = this.dateObj(start);

            for (let i = 0; i < daysCount; i++) {
              date = this.dateObj(days[i]);

                daily[d3.timeFormat('%m/%d/%Y')(date)] = this.getDailyData(filtered, date);
            }

            // add dates to header
            d3.select('#cont-dateRange')
                .text(`${this.longDateYr(this.dateObj(start))} - ${this.longDateYr(this.dateObj(end))}`)
                .append('span')
                .text(` (${daysCount} days)`);

            // return data for specified date range
//            console.log(dat)
//            console.log(daily)
            return daily;
        },
        // function to create a grid for 1 day's data
        /*
            This function will be called in a loop over the dailyData array (an array of data objects covering a range of dates).

            With each iteration of the loop, the function will be called to:
                1. Append a div.graph-grid to graphsGridContainer
                    A. Append a div.datecol to contain the date
                        i. Append an <h2> and add the date
                        ii. Append a <p> with the text "Glucose"
                    B. Append a div.graph to contain the <svg>
                        i. Append an <svg>
                        ii. Add the x & y axes
                        iii. Call a function to render the <path>(s)
                            (one path for each range of data:
                                high, normal, low)
        */
        createGrid(dayData) {
            // select graph container
//            console.log(dayData)
            const graphGridContainer = d3.select('#cont-graphs');

            // sort dayData by time
            dayData.sort((a, b) =>
                +d3.timeParse('%H:%M')(a.time) > +d3.timeParse('%H:%M')(b.time) ? 1 : -1
            );

            // get max value for y scale
            const yMax = Math.max(
                Math.max.apply(
                    Math,
                    dayData.map(d => +d['Historic Glucose mg/dL'])
                ),
                350
            );

            // x & y scales
            const xScale = d3
                .scaleTime()
                .domain([d3.timeParse('%H:%M')('0:00'), d3.timeParse('%H:%M')('24:01')])
                .range([0, this.width]);
            const yScale = d3.scaleLinear().domain([-70, yMax]).range([this.height, 0]);

            // get date, convert to Date object
            const date = this.dateObj(dayData[0].date);

            // add new grid
            const newGrid = graphGridContainer.append('div').attr('class', 'cont-graph-grid');

            // add graph info container
            const graphInfo = newGrid.append('div').attr('class', 'cont-datecol');
            // add the date
            graphInfo
                .append('h2')
                .text(this.abbrWeekday(date).toUpperCase() + ' ')
                .append('span')
                .text(this.shortDate(date));
            // add the name of the reading being graphed
            // (using "Glucose" as a placeholder for development)
            graphInfo
                .append('p')
                .attr('class', 'cont-graph-label')
                .text('Glucose')
                // units
                .append('span')
                .text(' mg/dL');

            // add the container for the graph
            const graphContainer = newGrid
                .append('div')
                .attr('class', 'cont-graph')
                .append('svg')
                .attr('width', this.width + this.margin.left + this.margin.right)
                .attr('height', this.height + this.margin.top + this.margin.bottom)
                .append('g')
                .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

            // add axes
            // x (top)
            graphContainer
                .append('g')
                .style('text-transform', 'lowercase')
                .call(
                    d3
                        .axisTop(xScale)
                        .ticks(d3.timeHour.every(2))
                        .tickFormat(d3.timeFormat('%-I%p'))
                        .tickPadding(10)
                        .tickSize(0)
                );

            // y
            graphContainer
                .append('g')
                .call(d3.axisLeft(yScale).tickValues([0, 70, 180, 350]));
            graphContainer
                .append('g')
                .attr('class', 'marker dark')
                .attr('transform', `translate(${this.width}, 0)`)
                .call(d3.axisRight(yScale).tickValues([0]).tickSize(-this.width));

            // highlight normal range
            const bandHeight = Math.abs(yScale(180) - yScale(70));
            graphContainer
                .append('g')
                .append('rect')
                .attr('x', 0)
                .attr('y', yScale(70) - bandHeight)
                .attr('height', bandHeight)
                .attr('width', this.width)
                .attr('fill', 'hsl(198 5% 85% / .5)');

            // vertical marker lines
            // dotted every hour
            graphContainer
                .append('g')
                .attr('class', 'marker marker--dotted')
                .attr('transform', `translate(0, ${this.height})`)
                .call(d3.axisBottom(xScale).ticks(d3.timeHour.every(1)).tickSize(-this.height));
            // solid every 6 hours
            graphContainer
                .append('g')
                .attr('class', 'marker marker--solid')
                .attr('transform', `translate(0, ${this.height})`)
                .call(d3.axisBottom(xScale).ticks(d3.timeHour.every(6)).tickSize(-this.height));

            // call renderPaths() function
            this.renderPaths(dayData, graphContainer, xScale, yScale);
        },
        // function to separate data by range (high, normal, low)
        getValueRanges(dailyData) {
            const rangeName = obj => {
                return +obj['Historic Glucose mg/dL'] < 70
                    ? 'low'
                    : +obj['Historic Glucose mg/dL'] < 180
                    ? 'normal'
                    : 'high';
            };

            // set starting data for first range
            let prevRange = rangeName(dailyData[0]);
            let rangeData = [[]];
            let currentIndex = 0;

            // create new array of objects for each range of data (high, normal, low)
            dailyData.forEach(d => {
                if (rangeName(d) === prevRange) {
                    d.range = prevRange;
                    rangeData[currentIndex].push(d);
                    return;
                }

                currentIndex++;
                prevRange = rangeName(d);
                d.range = prevRange;
                rangeData.push([d]);
            });

            if (rangeData.length <= 1) return rangeData;

            // append "connecting" datapoints between ranges (prevent gaps in lines)
            rangeData.forEach(range => {
                const index = rangeData.indexOf(range);
                const isLast = index === rangeData.length - 1;

                const endRangeTime = range[range.length - 1].time;
                const nextRangeStartTime = !isLast ? rangeData[index + 1][0].time : null;
                const prevRangeEndTime =
                    index > 0
                        ? rangeData[index - 1][rangeData[index - 1].length - 1].time
                        : null;
                const nextRange = !isLast ? rangeData[index + 1][0].range : null;
                const prevRange = index > 0 ? rangeData[index - 1][0].range : null;
                const connectorTime = (firstTime, secondTime) => {
                    const timeDiff = Math.abs(this.timeObj(secondTime) - this.timeObj(firstTime)); // difference in milliseconds

                    if (timeDiff < 2 * 1000 * 60) return secondTime;
                    if (timeDiff > 20 * 1000 * 60) return null; // allows gap in graph for time gaps > 20 minutes

                    return d3.timeFormat('%-H:%M')(+(this.timeObj(firstTime)) + timeDiff / 2); // add half of timeDiff in milliseconds, convert to 24-hour time format
                };

                const connectorVal = (thisRange, otherRange) => {
                    return thisRange === 'low'
                        ? 69.9
                        : thisRange === 'normal'
                        ? otherRange === 'low'
                            ? 70
                            : 179.9
                        : 180;
                };

                // exit loop and allow gap if > 20 minute time difference
                if (!isLast && !connectorTime(endRangeTime, nextRangeStartTime)) return;

                // if not last, append connector to end
                if (!isLast) {
                    range.push({
                        time: connectorTime(endRangeTime, nextRangeStartTime),
                        'Historic Glucose mg/dL': connectorVal(range[0].range, nextRange),
                        range: range[0].range,
                    });
                }

                // if not first, append connector to start
                if (index > 0) {
                    range.unshift({
                        time: prevRangeEndTime,
                        'Historic Glucose mg/dL': connectorVal(range[0].range, prevRange),
                        range: range[0].range,
                    });
                }
            });

            return rangeData;
        },
        // function to render paths for one day's data
        renderPaths(data, svg, xScale, yScale) {
            const graphDate = data[0].date;

            // split data into low, normal, high ranges
            const rangeData = this.getValueRanges(data);

            // loop over each rangeData object
            rangeData.forEach(datum => {
                // append a <g>, then a <path> to svg
                const path = svg
                    .append('g')
                    .attr('class', 'cont-path-container')
                    .append('path')
                    .datum(datum)
                    .attr('class', d => `cont-range-${d[0].range}`)
                    .attr('stroke-width', 1.5)
                    .attr('fill', 'none');
                // the line attributes
                path.attr(
                    'd',
                    d3
                        .line()
                        .x(d => xScale(+d3.timeParse('%H:%M')(d.time)))
                        .y(d => yScale(+d['Historic Glucose mg/dL']))
                );
            });

            // call plotScannedDatapoints() function
            this.plotScannedDatapoints(graphDate, svg, xScale, yScale);
        },
        // function to plot scanned data for specified date
        plotScannedDatapoints(date, svg, xScale, yScale) {
            const pointData = this.scannedData.filter(d => {
                // filter for specified date, exclude if no scanned value
                return +d['Scan Glucose mg/dL'] && d.date === date;
            });

            // plot points
            // hover data container
            const dataDisplayDiv = d3.select('#cont-hover-data').style('opacity', 0);

            const hover = d => {
                dataDisplayDiv
                    .style('opacity', 1)
                    .html(
                        `
                        <p class="cont-grey-6">${d.srcElement.dataset.time}</p>
                        <p style="font-weight: bold;">${d.srcElement.dataset.val}</p>
                    `
                    )
                    .style('left', d.x + 5 + 'px')
                    .style('top', d.y + 'px');
            };
            const hoverOut = d => {
                dataDisplayDiv.style('opacity', 0);
            };

            svg
                .append('g')
                // this selectAll() returns nothing but is required
                .selectAll('dots')
                .data(pointData)
                .enter()
                .append('circle')
                .attr('class', 'dot cont-range-normal')
                .attr('fill', 'white')
                .attr('cx', d => xScale(+(this.timeObj(d.time))))
                .attr('cy', d => yScale(+d['Scan Glucose mg/dL']))
                .attr('r', 3)
                // data attributes to display on hover
                .attr('data-time', d => this.timeTwelve(this.timeObj(d.time)))
                .attr('data-val', d => d['Scan Glucose mg/dL'])
                // display data on hover
                .on('mouseover', hover)
                .on('mouseout', hoverOut);
        }
    }

}

</script>
<style>
@import './cont-graph.css';
/* :root {
	--hue-blue: 205;
	--clr-accent-8: hsl(var(--hue-blue) 54% 52%);
	--clr-accent-7: hsl(var(--hue-blue) 54% 66%);
	--clr-grey-9: hsl(198 5% 10%);
	--clr-grey-8: hsl(198 5% 28%);
	--clr-grey-7: hsl(198 5% 38%);
	--clr-grey-6: hsl(198 5% 50%);
	--clr-grey-5: hsl(198 5% 63%);
	--clr-white: hsl(198 5% 98%);

	--clr-low: hsl(357 80% 47%);
	--clr-high: hsl(35 92% 57%);
	--clr-normal: hsl(207 86% 30%);
	--clr-gold: hsl(45 89% 50%);
	--clr-green: hsl(86 55% 51%);
} */

/* color utility classes */
.cont-grey-9 {
	color: var(--clr-grey-9);
}
.cont-grey-8 {
	color: var(--clr-grey-8);
}
.cont-grey-7 {
	color: var(--clr-grey-7);
}
.cont-grey-6 {
	color: var(--clr-grey-6);
}
.cont-grey-5 {
	color: var(--clr-grey-5);
}

.cont-body {
	margin: 0;
	background-color: var(--clr-accent-7);
	font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
		'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	color: var(--clr-grey-9);
	height: 100vh;
}

/* p,
h1,
h2 {
	margin: 0;
} */

/* h1 {
	color: var(--clr-accent-8);
}
h2 {
	color: var(--clr-accent-7);
	font-weight: 400;
}
h2 > span {
	font-weight: 700;
} */

#cont-daily-log {
	height: 100%;
	display: grid;
	grid-template-rows: auto 1fr auto;
}
#cont-graphs {
	overflow: auto;
}

.cont-container {
	background-color: var(--clr-white);
	width: 85rem;
	margin: 0 auto;
}

.cont-subhead {
	font-weight: 700;
	color: var(--clr-grey-6);
}
.cont-subhead > span {
	font-weight: 400;
	font-size: 0.875rem;
	color: var(--clr-grey-5);
}

/* the grid */
.cont-graph-grid {
	display: grid;
	grid-template-columns: 12rem 1fr;
	gap: 1em;
	margin: 2em 4px;
}

.cont-datecol {
	grid-column: 1 / 2;
	font-size: 0.75rem;
	margin-block-end: 3em;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.cont-graph {
	grid-column: 2 / 3;
	width: 100%;
}

.cont-graph-label {
	margin-inline-start: 1em;
	font-weight: 700;
}
.cont-graph-label > span {
	font-weight: 400;
	font-size: 90%;
}

/* range colors */
.cont-range-high {
	stroke: var(--clr-high);
}
.cont-range-normal {
	stroke: var(--clr-normal);
}
.cont-range-low {
	stroke: var(--clr-low);
}

/* graph marker lines */
.marker {
	--strokeColor: hsl(198 5% var(--strokeL, 80%));
	--strokeWidth: 1.5;
}
.marker.dark {
	--strokeL: 10%;
}
.marker line {
	stroke: var(--strokeColor);
	stroke-width: var(--strokeWidth);
}
.marker text {
	display: none;
}
.marker--dotted {
	--strokeWidth: 0.5;
}
.marker--dotted line {
	stroke-dasharray: 5, 5;
}

/* datapoint container (displays on hover) */
.cont-hover-data {
	padding: 0.25em;
	background-color: #fff;
	color: var(--clr-grey-9);
	border: 2px solid var(--clr-grey-9);
	width: fit-content;
	position: fixed;
	text-align: center;
	font-size: 0.75rem;
	transition: opacity 250ms;
}

/* graph legend */
.cont-legend {
	color: var(--clr-grey-6);
	font-size: 0.625rem;
	padding: 2em 0.125em 1em;
	display: flex;
	align-items: center;
	gap: 2em;
}
.cont-legend > p {
	color: var(--clr-grey-9);
	font-weight: 600;
}

.key {
	display: inline-flex;
	flex-wrap: nowrap;
	gap: 0.5em;
	align-items: center;
	line-height: max(1.125em, var(--key-dimensions));
	--key-color: var(--clr-normal);
	--key-dimensions: 1.125em;
	--key-radius: 0;
}
.key.circle {
	--key-dimensions: 0.5em;
	--key-radius: 50%;
}
.key.high {
	--key-color: var(--clr-high);
}
.key.low {
	--key-color: var(--clr-low);
}
.key .green {
	color: var(--clr-green);
}
.key.grey-5 {
	--key-color: var(--clr-grey-5);
}

.key::before {
	content: '';
	display: inline-block;
	min-width: var(--key-dimensions);
	min-height: var(--key-dimensions);
	background-color: var(--key-color);
	border: 2px solid var(--key-border, var(--key-color));
	border-radius: var(--key-radius);
}
.key[data-keytext]::before {
	content: attr(data-keytext);
	padding: 0.5em 0.625em;
	font-weight: 600;
}
.key.nofill::before {
	background-color: transparent;
}
.key.noborder::before {
	border-color: transparent;
}
</style>
